// extracted by mini-css-extract-plugin
module.exports = {"wrapperInner":"CTAMessage-module--wrapperInner--3zP0O","button":"CTAMessage-module--button--2OiK8"};